/* eslint-disable react-hooks/exhaustive-deps */
import { React, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { customDelete, customGet, customPost, customPut } from "../../../utils/services";
import SelectAC from "react-select";
import makeAnimated from "react-select/animated";
import Input from "../../../components/common/Input";
import Select from "../../../components/common/Select";
import Button from "../../../components/common/Button";
import Table from "../../../components/common/Table";
import Spinner from "../../../components/common/Spinner";
import { TrashIcon } from "@heroicons/react/solid";
import toast from "react-hot-toast";
import moment from "moment";

const { REACT_APP_API_URL } = process.env;

export const VentaDirecta = () => {
  const token = useSelector((state) => state.loginReducer.data.token);
  const usuarioNombre = useSelector((state) => state.loginReducer.data.userData?.name);
  const usuarioId = useSelector((state) => state.loginReducer.data.userData?.id);
  const animatedComponents = makeAnimated();

  // Productos
  const [productos, setProductos] = useState([]);
  const [productoSeleccionado, setProductoSeleccionado] = useState(null);
  const [cantidad, setCantidad] = useState(1);
  const [detalle, setDetalle] = useState([]);
  const [observacion, setObservacion] = useState("Venta directa");
  const [creandoOrden, setCreandoOrden] = useState(false);

  // Orden creada
  const [ordenId, setOrdenId] = useState(null);

  // Pagos
  const [tipoPagos, setTipoPagos] = useState([]);
  const [tipoPagoId, setTipoPagoId] = useState("");
  const [monto, setMonto] = useState("");
  const [referencia, setReferencia] = useState("");
  const [noDocumento, setNoDocumento] = useState("");
  const [pagosOrden, setPagosOrden] = useState([]);
  const [totalPagos, setTotalPagos] = useState(0);
  const [puedeFinalizar, setPuedeFinalizar] = useState(false);
  const [loadingPago, setLoadingPago] = useState(false);
  const [finalizando, setFinalizando] = useState(false);

  const total = detalle.reduce((acc, item) => acc + item.precio * item.cantidad, 0);

  const estiloOk = "bg-green-100 text-green-600 border-4 border-green-500";
  const estiloPendiente = "bg-red-100 text-red-600 border-4 border-red-500";

  useEffect(() => {
    customPost(undefined, "catalogos/menus", token).then((data) => {
      const lista = Array.isArray(data) ? data : (data?.data || []);
      setProductos(lista.map((p) => ({
        value: p.id,
        label: `${p.categoria?.nombre} / ${p.nombre} / Q${p.precio}`,
        precio: parseFloat(p.precio),
        nombre: p.nombre,
        categoria: p.categoria?.nombre || "",
      })));
    });

    customPost(undefined, "catalogos/res-tipo-pagos", token).then((data) => {
      setTipoPagos(Array.isArray(data) ? data : (data?.data || []));
    });
  }, []);

  // --- Productos ---

  const handleAgregar = () => {
    if (!productoSeleccionado) {
      toast.error("Debe seleccionar un producto");
      return;
    }
    if (!cantidad || Number(cantidad) <= 0) {
      toast.error("La cantidad debe ser mayor a 0");
      return;
    }
    setDetalle([...detalle, {
      menu_id: productoSeleccionado.value,
      nombre: productoSeleccionado.nombre,
      categoria: productoSeleccionado.categoria,
      precio: productoSeleccionado.precio,
      cantidad: Number(cantidad),
    }]);
    setProductoSeleccionado(null);
    setCantidad(1);
  };

  const handleEliminarProducto = (index) => {
    setDetalle(detalle.filter((_, i) => i !== index));
  };

  // --- Crear orden ---

  const handleCrearOrden = async () => {
    if (detalle.length === 0) {
      toast.error("Debe agregar al menos un producto");
      return;
    }
    setCreandoOrden(true);
    try {
      const postData = await customPost(
        {
          observacion: `${observacion} ${moment().format("DD-MM-YYYY hh:mm:ss")}`,
          mesa: "",
          habitacion: "",
          vendedor: usuarioNombre,
          vendedor_id: String(usuarioId),
          detalle: detalle.map((item) => ({
            menu_id: item.menu_id,
            cantidad: item.cantidad,
            opciones: "[]",
          })),
        },
        "ventas",
        token
      );

      if (postData?.status >= 200 && postData?.status <= 210) {
        const id = postData.data.data.id;

        const orden = await customGet(undefined, `ventas/${id}`, token);

        await Promise.all(
          orden.detalle.map((item) =>
            customPut(item.id, {}, "ventas/detalle/delivered", token)
          )
        );

        setOrdenId(id);
        setMonto(total.toFixed(2));
        toast.success(postData.data.msg || "Orden creada exitosamente");
      }
    } catch (error) {
      if (error?.response?.status >= 400 && error?.response?.status <= 450) {
        toast.error(error.response.data.error);
      } else {
        toast.error("Error interno, comuniquese con el administrador");
      }
    }
    setCreandoOrden(false);
  };

  // --- Pagos ---

  const handleAgregarPago = async () => {
    if (!tipoPagoId || !monto) {
      toast.error("Tipo de pago y monto son requeridos");
      return;
    }
    if (Number(tipoPagoId) !== 1 && Number(tipoPagoId) !== 5 && noDocumento === "") {
      toast.error("El número de documento no puede estar vacío");
      return;
    }

    const pendiente = total - totalPagos;
    const montoAplicado = Number(monto) > pendiente ? pendiente : Number(monto);
    const tipoPagoNombre = tipoPagos.find((t) => String(t.id) === String(tipoPagoId))?.nombre || "";

    const pago = {
      tipo_pago_id: Number(tipoPagoId),
      monto: montoAplicado,
      no_documento: noDocumento,
      referencia,
      tipo_pago: { id: Number(tipoPagoId), nombre: tipoPagoNombre },
    };

    setLoadingPago(true);
    await customPost(pago, `ventas/pagos/${ordenId}`, token)
      .then((data) => {
        if (data?.status >= 200 && data?.status <= 210) {
          toast.success(data?.data?.msg);

          const nuevoPago = { ...data.data.data, tipo_pago: pago.tipo_pago };
          const nuevosPagos = [...pagosOrden, nuevoPago];
          setPagosOrden(nuevosPagos);

          const nuevaSum = nuevosPagos.reduce((acc, p) => acc + Number(p.monto), 0);
          setTotalPagos(nuevaSum);
          if (nuevaSum >= total) setPuedeFinalizar(true);

          setTipoPagoId("");
          setMonto("");
          setReferencia("");
          setNoDocumento("");
        }
      })
      .catch((error) => {
        if (error.response.status >= 400 && error.response.status <= 450) {
          toast.error(error.response.data.error);
        } else {
          toast.error("Error interno comuniquese con el administrador");
        }
      })
      .finally(() => setLoadingPago(false));
  };

  const handleEliminarPago = (id) => {
    customDelete(id, "ventas/pagos", token).then(() => {
      toast.success("Pago eliminado con exito");
      const filtrados = pagosOrden.filter((p) => p.id !== id);
      setPagosOrden(filtrados);
      const nuevaSum = filtrados.reduce((acc, p) => acc + Number(p.monto), 0);
      setTotalPagos(nuevaSum);
      if (nuevaSum < total) setPuedeFinalizar(false);
    });
  };

  // --- Finalizar ---

  const handleFinalizarOrden = async () => {
    setFinalizando(true);
    await customPost(undefined, `ventas/finalizar/${ordenId}`, token)
      .then((data) => {
        if (data?.status >= 200 && data?.status <= 210) {
          toast.success("Venta finalizada con exito");
          window.open(`${REACT_APP_API_URL}/imprimir-orden/${ordenId}`, "_blank");
          setDetalle([]);
          setObservacion("Venta directa");
          setOrdenId(null);
          setPagosOrden([]);
          setTotalPagos(0);
          setPuedeFinalizar(false);
          setTipoPagoId("");
          setMonto("");
        }
      })
      .catch((error) => {
        if (error.response.status >= 400 && error.response.status <= 450) {
          toast.error(error.response.data.error);
        } else {
          toast.error("Error interno comuniquese con el administrador");
        }
      });
    setFinalizando(false);
  };

  return (
    <div className="p-3 border rounded-lg m-3">
      <h1 className="text-xl font-bold text-primaryFont mb-2">Venta directa</h1>

      <div className="grid grid-cols-12 gap-4">

        {/* Panel izquierdo */}
        <div className="col-span-12 xl:col-span-4 lg:col-span-5">
          <div className="border rounded-lg p-5 shadow-sm bg-white space-y-4">

            {/* Sección producto — se oculta cuando la orden ya fue creada */}
            {!ordenId && (
              <>
                <p className="text-xs font-semibold text-primaryFont uppercase tracking-wide">Producto</p>
                <div>
                  <label className="block text-xs font-medium text-primaryFont mb-1">Menu</label>
                  <SelectAC
                    placeholder="Buscar producto..."
                    components={animatedComponents}
                    options={productos}
                    value={productoSeleccionado}
                    onChange={setProductoSeleccionado}
                    isClearable
                    className="text-xs"
                    maxMenuHeight={200}
                    noOptionsMessage={() => "No se encontraron productos"}
                  />
                </div>
                <div>
                  <Input
                    type="number"
                    name="cantidad"
                    label="Cantidad"
                    value={cantidad}
                    onChange={(e) => setCantidad(e.target.value)}
                    minimo={1}
                  />
                </div>
                <div className="flex justify-end">
                  <Button text="Agregar" type="button" onClick={handleAgregar} className="w-32" />
                </div>
              </>
            )}

            {/* Sección pago — aparece luego de crear la orden */}
            {ordenId && (
              <>
                <p className="text-xs font-semibold text-primaryFont uppercase tracking-wide">Pago</p>
                <div>
                  <Select
                    id="tipoPagoId"
                    name="tipoPagoId"
                    value={tipoPagoId}
                    onChange={(e) => {
                      setTipoPagoId(e.target.value);
                      setNoDocumento("");
                    }}
                    label="Tipo de pago"
                    valueInit=""
                    selectInit="Seleccionar tipo de pago"
                    list={tipoPagos.map((item) => (
                      <option key={item.id} value={item.id}>{item.nombre}</option>
                    ))}
                  />
                </div>
                <div>
                  <Input
                    type="number"
                    name="monto"
                    label="Monto"
                    value={monto}
                    onChange={(e) => setMonto(e.target.value)}
                    minimo={0}
                  />
                </div>
                <div>
                  <Input
                    type="text"
                    name="referencia"
                    label="Referencia"
                    value={referencia}
                    onChange={(e) => setReferencia(e.target.value)}
                  />
                </div>
                {tipoPagoId && Number(tipoPagoId) !== 1 && Number(tipoPagoId) !== 5 && (
                  <div>
                    <Input
                      type="text"
                      name="noDocumento"
                      label="No. Documento"
                      value={noDocumento}
                      onChange={(e) => setNoDocumento(e.target.value)}
                    />
                  </div>
                )}
                <div className="flex justify-end">
                  {loadingPago
                    ? <Spinner />
                    : <Button text="Agregar pago" type="button" onClick={handleAgregarPago} className="w-32" />
                  }
                </div>
              </>
            )}
          </div>
        </div>

        {/* Panel derecho */}
        <div className="col-span-12 xl:col-span-8 lg:col-span-7 space-y-4">

          {/* Tabla de productos */}
          <div className="border rounded-lg overflow-x-auto shadow-sm bg-white">
            <Table
              headers={["Producto", "Categoria", "Precio", "Cantidad", "Subtotal", ""]}
              body={detalle.map((item, index) => (
                <tr key={index}>
                  <td className="px-3 py-2 text-xs text-primaryFont">{item.nombre}</td>
                  <td className="px-3 py-2 text-xs text-primaryFont">{item.categoria}</td>
                  <td className="px-3 py-2 text-xs text-primaryFont">Q{item.precio}</td>
                  <td className="px-3 py-2 text-xs text-primaryFont">{item.cantidad}</td>
                  <td className="px-3 py-2 text-xs text-primaryFont font-medium">
                    Q{(item.precio * item.cantidad).toFixed(2)}
                  </td>
                  <td className="px-3 py-2 text-xs">
                    {!ordenId && (
                      <button
                        type="button"
                        onClick={() => handleEliminarProducto(index)}
                        className="hover:bg-red-100 rounded-lg p-1"
                      >
                        <TrashIcon className="h-5 w-5 text-red-500" />
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            />
            <div className="flex justify-between items-center px-4 py-3 border-t bg-gray-50 gap-3">
              <span className="text-sm font-bold text-primaryFont whitespace-nowrap">
                Total: Q{total.toFixed(2)}
              </span>
              {!ordenId && detalle.length > 0 && (
                <div className="flex items-end gap-2 flex-1 justify-end">
                  <div className="w-64">
                    <Input
                      type="text"
                      name="observacion"
                      label="Observacion"
                      value={observacion}
                      onChange={(e) => setObservacion(e.target.value)}
                    />
                  </div>
                  {creandoOrden
                    ? <Spinner />
                    : <Button text="Crear orden" type="button" onClick={handleCrearOrden} className="w-32" />
                  }
                </div>
              )}
            </div>
          </div>

          {/* Sección pagos — aparece luego de crear la orden */}
          {ordenId && (
            <div className="border rounded-lg shadow-sm bg-white">

              {/* Tarjetas totales */}
              <div className="flex justify-center items-center gap-3 p-4 flex-wrap">
                <div className="p-3 w-36 bg-primaryOpacity text-center rounded-lg border-4 border-blue-500">
                  <p className="text-xs text-primaryFont">Total orden</p>
                  <span className="text-sm font-bold text-primaryFont">Q{total.toFixed(2)}</span>
                </div>
                <div className={`p-3 w-36 text-center rounded-lg ${puedeFinalizar ? estiloOk : estiloPendiente}`}>
                  <p className="text-xs">Pendiente</p>
                  <span className="text-sm font-bold">Q{(total - totalPagos).toFixed(2)}</span>
                </div>
                <div className={`p-3 w-36 text-center rounded-lg ${puedeFinalizar ? estiloOk : estiloPendiente}`}>
                  <p className="text-xs">Total pagos</p>
                  <span className="text-sm font-bold">Q{totalPagos.toFixed(2)}</span>
                </div>
              </div>

              {/* Tabla de pagos */}
              <div className="px-4 pb-2">
                <Table
                  headers={["Tipo pago", "Monto", "Eliminar"]}
                  body={pagosOrden.map((item, index) => (
                    <tr key={item?.tipo_pago?.nombre + index} className="hover:bg-slate-100">
                      <td className="px-3 py-2 text-xs text-primaryFont">{item?.tipo_pago?.nombre}</td>
                      <td className="px-3 py-2 text-xs text-primaryFont">Q{item?.monto}</td>
                      <td className="px-3 py-1">
                        <button
                          type="button"
                          onClick={() => handleEliminarPago(item.id)}
                          className="hover:bg-red-100 rounded-lg p-1"
                        >
                          <TrashIcon className="h-5 w-5 text-red-500" />
                        </button>
                      </td>
                    </tr>
                  ))}
                />
              </div>

              {puedeFinalizar && (
                <div className="flex justify-end px-4 pb-4">
                  {finalizando
                    ? <Spinner />
                    : <Button text="Finalizar orden" type="button" onClick={handleFinalizarOrden} className="w-40" />
                  }
                </div>
              )}
            </div>
          )}

        </div>
      </div>
    </div>
  );
};
